import { ParentEvent, ViewerModule } from '@g.frame/core';
import { Loader } from '@g.frame/common.loaders';
import { ActionController } from '@g.frame/common.action_controller';
export default class Stage extends ViewerModule {
    constructor(modulesProcessor, uiManager, environment) {
        super();
        this.modulesProcessor = modulesProcessor;
        this.uiManager = uiManager;
        this.environment = environment;
        this.isActive = false;
        this.completed = false;
        this.loader = this.modulesProcessor.agents.get(Loader);
        this.actionController = this.modulesProcessor.agents.get(ActionController);
    }
    init() {
    }
    startLevel() {
        // this.uiManager.progressUpdate(0);
    }
    showStartMessage() {
        const pop = {
            header: 'Welcome',
            body: 'Today we are going to focus on learning agriculture science. Explore the farm and click an object below to get started.',
            button: 'Continue',
            type: 'hint',
        };
        this.uiManager.on('first_button_click', () => {
            this.uiManager.off('first_button_click');
            this.fire('start_level', new ParentEvent('start_level'));
        });
        this.uiManager.showWelcomePopUp(pop);
    }
    showFinalMessage(levelName, allLevelsFinished) {
        const pop = {
            body: allLevelsFinished ?
                `Congratulations! You’ve completed all three levels, including ${levelName} level.` :
                `Good job! You’ve completed the ${levelName} level.`,
            secondButton: allLevelsFinished ?
                `Back To Lobby` :
                `Next Level`,
        };
        if (allLevelsFinished) {
            pop['header'] = `Simulation Finish`;
        }
        this.completed = true;
        this.uiManager.hide();
        this.uiManager.showFinalPopUp(pop);
        this.uiManager.on('first_button_click', () => {
            this.uiManager.off('first_button_click');
            this.uiManager.off('second_button_click');
            this.uiManager.hidePopUpScreen();
            this.fire('restart_level', new ParentEvent('restart_level'));
        });
        this.uiManager.on('second_button_click', () => {
            this.uiManager.off('first_button_click');
            this.uiManager.off('second_button_click');
            this.uiManager.hidePopUpScreen();
            this.fire('next_level_button', new ParentEvent('next_level_button'));
        });
    }
    beforeEnable() {
    }
    enable() {
        this.isActive = true;
    }
    disable() {
        this.isActive = false;
    }
    finishedEvent() {
        this.fire('finished');
    }
    resetStage() {
    }
}
